export class Accordion {
  private readonly item: HTMLElement;
  private readonly trigger: HTMLButtonElement;
  private readonly panel: HTMLElement;

  constructor(item: HTMLElement) {
    this.item = item;
    this.trigger = item.querySelector<HTMLButtonElement>('.accordion__trigger')!;
    this.panel = item.querySelector<HTMLElement>('.accordion__panel')!;

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', () => this.toggle());
    this.trigger.addEventListener('keydown', (e: KeyboardEvent) => this.onKeydown(e));
  }

  private toggle(): void {
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) { this.close(); } else { this.open(); }
  }

  open(): void {
    this.panel.removeAttribute('hidden');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close(): void {
    this.panel.setAttribute('hidden', '');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  private onKeydown(e: KeyboardEvent): void {
    const list = this.item.closest<HTMLElement>('.accordion__list');
    if (!list) return;

    const triggers = Array.from(list.querySelectorAll<HTMLButtonElement>('.accordion__trigger'));
    const idx = triggers.indexOf(this.trigger);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      triggers[(idx + 1) % triggers.length]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      triggers[(idx - 1 + triggers.length) % triggers.length]?.focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      triggers[0]?.focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      triggers[triggers.length - 1]?.focus();
    }
  }

  static initAll(selector = '.accordion__list'): void {
    document.querySelectorAll<HTMLElement>(selector).forEach((list) => {
      list.querySelectorAll<HTMLElement>('.accordion__item').forEach((item) => {
        new Accordion(item);
      });
    });
  }
}
